import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

// Helper function to simulate API delay
const delay = (ms = 500) => new Promise((resolve) => setTimeout(resolve, ms));

// Helper function to simulate random errors (10% chance)
const shouldError = () => Math.random() < 0.1;

// Mock API base URL - replace with real backend URL when integrating
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://www.kobraia.com'//'http://localhost:5000';

export const mockApiCall = async (data, errorMessage = 'An error occurre', delayMs = 500) => {
  await delay(delayMs);
  if (shouldError()) {
    throw new Error(errorMessage);
  }
  return data;
};

export { API_BASE_URL };

